import { DEFAULT_COLOR_SWATCHES, IMAGE_OPTIMIZATION_THRESHOLD_WIDTH } from '../../domain/constants.js';

export const DISPLAY_MODE = {
  static: 'static',
  interactive: 'interactive'
};

export const DEFAULT_WAVEFORM_WIDTH = IMAGE_OPTIMIZATION_THRESHOLD_WIDTH;
export const DEFAULT_WAVEFORM_HEIGHT = Math.round(IMAGE_OPTIMIZATION_THRESHOLD_WIDTH / 2.5);
export const DEFAULT_WAVEFORM_PEN_WIDTH = 2;
export const DEFAULT_WAVEFORM_SMOOTHING = true;
export const DEFAULT_WAVEFORM_PEN_COLOR = DEFAULT_COLOR_SWATCHES[1][3];
export const DEFAULT_WAVEFORM_BASELINE_COLOR = DEFAULT_COLOR_SWATCHES[1][0];
export const DEFAULT_WAVEFORM_BACKGROUND_COLOR = DEFAULT_COLOR_SWATCHES[1][8];
